import { render, staticRenderFns } from "./InsCmsPersonSwiper.vue?vue&type=template&id=7907b6fc&scoped=true&"
import script from "./InsCmsPersonSwiper.vue?vue&type=script&lang=ts&"
export * from "./InsCmsPersonSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsPersonSwiper.vue?vue&type=style&index=0&id=7907b6fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7907b6fc",
  null
  
)

export default component.exports